import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { RefuelEuContribution } from '../../../../components/widgets/airport/refuel-eu/refuel-eu-contribution/refuel-eu-contribution';
import { connectNLP } from '../../../../utilities/connect-navigate';
import { Contributions } from './contributions';

const mapStateProps = (store: any) => ({
	user: store.user.user,
});

const mapDispatchProps = (dispatch: any) => ({});

class RefuelEuContributionsComponent extends Contributions<any, any> {
	public endpoint(): any {
		const user = get(this.props, 'user');
		const userRoles = get(user, 'roles');
		const isAdmin = userRoles.includes('ADMIN');
		const system = get(this.props, 'system');
		const systemInfo = system === true ? '/system' : `/users/${system}`;
		const otherInfo = isAdmin ? '' : `/users/${get(user, 'aid')}`;

		const systemAdminOrGeneral = isAdmin && system ? systemInfo : otherInfo;

		return `/airportrefueleus/contributions${systemAdminOrGeneral}`;
	}

	public getType(): string {
		return 'refueleu';
	}

	public getModalEndpoint() {
		return `/airportrefueleus/${get(this.state.item, 'entityAid')}`;
	}

	public renderModalContent(ctx): React.ReactElement {
		return (
			<RefuelEuContribution
				endpoint='/airportrefueleus/merge'
				original={get(ctx.state, 'response')}
				item={this.state.item}
				onSuccess={() => this.handleModalSuccess()}
				close={() => this.onModalClose()}
			/>
		);
	}
}

export const RefuelEuContributions: any = connect(
	mapStateProps,
	mapDispatchProps,
	null,
	{ forwardRef: true }
)(connectNLP(RefuelEuContributionsComponent));
